/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect } from 'react';
import "./ContentPage.scss";
import { AppContext } from '../../Stores/App.store';
import TopBar from '../TopBar/TopBar';
import Footer from '../Footer/Footer';
import { Country } from '../../Types/LocationTypes';
import { navigationPush, vPush } from '../../Services/Analytics';

const ContentPage = () => {
    const { selectedArticle, setSelectedArticle, continents, pageView } = useContext(AppContext)!;
    const PressedArticle = (country: Country) => {
        vPush(`/trips-memories/article/${country.ID}`, `נזכרים בטיולים - ${country.Title}`);
        navigationPush("Side Menu Clicks", country.Name + " - " + country.Title);
        setSelectedArticle(country);
    }
    var scrollPercent = 0;
    const GoToSelectedArticle = () => {
        navigationPush("Click To Article", selectedArticle?.Title);
        window.open(selectedArticle?.ArticleUrl, "_blank")
    }

    useEffect(() => {
        let articleListEl = document.getElementById("article-list-container");
        articleListEl?.addEventListener("scroll", e => {

            let percent = (articleListEl?.scrollTop! + articleListEl?.clientHeight!) / articleListEl?.scrollHeight! * 100;

            if (percent > scrollPercent) {
                if (scrollPercent === 0 && percent > 25) {
                    scrollPercent = 25;
                    navigationPush("Scroll", `${scrollPercent}%`)
                } else if (scrollPercent === 25 && percent >= 50) {
                    scrollPercent = 50;
                    navigationPush("Scroll", `${scrollPercent}%`)

                } else if (scrollPercent === 50 && percent >= 75) {
                    scrollPercent = 75;
                    navigationPush("Scroll", `${scrollPercent}%`)

                } else if (scrollPercent === 75 && percent >= 100) {
                    scrollPercent = 100;
                    navigationPush("Scroll", `${scrollPercent}%`)


                }
            }

        })
    }, [])

    return (
        <div id="content-page" className={pageView}>
            <div id="article-view">
                <div className="grad-top"></div>
                <TopBar />
                <div className={`bg image-${selectedArticle?.ID}`}></div>
                <div className="text-wrapper" onClick={() => GoToSelectedArticle()}>
                    <h2>{selectedArticle?.Title}</h2>
                    <h3>{selectedArticle?.Description}</h3>
                    <div className="read-more">לקריאת הכתבה</div>
                </div>
                <div className="grad-bottom"></div>
            </div>
            <div id="article-list">
                <div id="article-list-container">

                    {continents?.map((cont, contIndex) => {
                        return (
                            <div className="continent" key={cont.Name}>
                                <h2>{cont.Name}</h2>
                                {cont.Countries.map((country, countryIndex) => {
                                    return (
                                        <div className="country" onClick={() => PressedArticle(country)} key={country.Description}>
                                            <div className={`image image-${country.ID}`}></div>
                                            <div className="text-area">
                                                <h3>{country.Name}</h3>
                                                <h4>{country.Title}</h4>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        )
                    })}
                    <div className="footer">
                        <Footer type="small" />
                    </div>
                </div>

            </div>

        </div>
    )
}

export default ContentPage
